export const navigationItems = [
  {
    path: "/",
    label: "मुख्य पृष्ठ",
    icon: "🏠"
  },
  {
    path: "/introduction",
    label: "परिचय",
    icon: "📖"
  },
  {
    path: "/board",
    label: "प्रबंध मंडल",
    icon: "👥"
  },
  {
    path: "/annual-plan",
    label: "वार्षिक कार्ययोजना",
    icon: "📋"
  },
  {
    path: "/achievements",
    label: "उपलब्धियाँ",
    icon: "🏆"
  },
  {
    path: "/gallery",
    label: "गैलरी",
    icon: "🖼️"
  },
  {
    path: "/product",
    label: "तैयार उत्पाद",
    icon: "📦"
  },
  {
    path: "/educommittee",
    label: "बीकानेर प्रौढ़ शिक्षण समिति",
    icon: "🎓"
  },
  {
    path: "/contact",
    label: "संपर्क",
    icon: "📞"
  }
];
